import { Table, type ToolbarElements, useTableRefetch } from '@synqo/frontend-component-library';
import { ApiDynamicExportRun } from '@Model';
import { DOCUMENTS_API } from '@Constants/backendConstants';
import { exportRunColumns } from '@Constants/TableColumns';
import { useExportRunDetailModal } from './useExportRunDetailModal';
import { useListApi } from '@Hooks/useListApi';
import { useOpenFromQuery } from '@Hooks/useOpenFromQuery';
import { useRemoteCacheInvalidation } from '@Hooks/useRemoteCacheInvalidation';
import { useDocumentsRepository } from '@Hooks/useRepository';
import { useCallback } from 'react';
import { DynamicExportRunRepository } from '@Repositories/Documents';

const EXPORT_RUNS = 'exports';

interface FrameListExportRunsProps {
    toolbarElements?: ToolbarElements;
}

/**
 * The export runs the caller may see, newest first; a row, or the run named in the link, opens its detail panel.
 */
export function FrameListExportRuns({ toolbarElements }: FrameListExportRunsProps) {
    const module = useListApi(DynamicExportRunRepository, DOCUMENTS_API);
    const runs = useDocumentsRepository(DynamicExportRunRepository);
    const openRunDetail = useExportRunDetailModal();
    const loadRun = useCallback((id: string) => runs.get(id, undefined), [runs]);
    useOpenFromQuery(loadRun, openRunDetail);
    const { refetchRef, refetchTable } = useTableRefetch();
    useRemoteCacheInvalidation(EXPORT_RUNS, refetchTable);

    return (
        <Table<ApiDynamicExportRun>
            name={'DynamicExportRunsList'}
            columns={exportRunColumns}
            loader={module.loadPage}
            refetchRef={refetchRef}
            onSelect={openRunDetail}
            initialSorting={{
                columnName: 'created_at',
                direction: 'desc',
            }}
            toolbarElements={toolbarElements}
            canCreate={false}
            fullSize
        />
    );
}
